import type { SVGProps } from "react";
import * as React from "react";
const SvgTogetherai = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#Togetherai_svg__a)">
      <path
        fill="#448FFF"
        d="M0 4a4 4 0 0 1 4-4h16a4 4 0 0 1 4 4v16a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4Z"
      />
      <path
        fill="#000"
        d="M4.172 10.466H3V9.51h1.172V7.688h1.045V9.51h1.644v.956H5.217v3.836c0 .272.051.467.153.586.11.11.298.166.561.166h1.134v.956H5.867c-.611 0-1.049-.136-1.312-.408-.255-.272-.383-.701-.383-1.287v-3.849ZM19.31 15.054v.956h-.574c-.416 0-.713-.085-.892-.255-.178-.17-.272-.42-.28-.752-.502.722-1.228 1.083-2.18 1.083-.722 0-1.303-.17-1.745-.51-.434-.34-.65-.803-.65-1.389 0-.654.22-1.155.662-1.503.45-.349 1.1-.523 1.95-.523h1.912v-.446c0-.425-.145-.756-.434-.994-.28-.238-.675-.357-1.185-.357-.45 0-.824.102-1.121.306a1.22 1.22 0 0 0-.535.79h-1.045c.076-.637.357-1.134.84-1.49.494-.358 1.13-.536 1.912-.536.833 0 1.474.204 1.924.612.46.399.689.977.689 1.733v2.803c0 .315.144.472.433.472h.319Zm-1.797-2.014h-2.014c-.968 0-1.452.362-1.452 1.084 0 .322.127.582.382.777.255.195.599.293 1.032.293.637 0 1.138-.166 1.504-.497.365-.34.548-.786.548-1.338v-.319ZM20.426 7a.655.655 0 0 1 .676.675.656.656 0 0 1-.676.676.655.655 0 0 1-.676-.676.655.655 0 0 1 .676-.675Zm-.523 2.51h1.045v6.5h-1.045v-6.5Z"
      />
      <path
        fill="#fff"
        d="M10.946 15.02c0 .547-.449.99-1.002.99a.996.996 0 0 1-1.002-.99c0-.546.449-.99 1.002-.99a.996.996 0 0 1 1.002.99Z"
      />
    </g>
    <defs>
      <clipPath id="Togetherai_svg__a">
        <rect width={24} height={24} fill="#fff" rx={4} />
      </clipPath>
    </defs>
  </svg>
);
export default SvgTogetherai;
